import { render, staticRenderFns } from "./Usuarios.vue?vue&type=template&id=2858271a&"
import script from "./Usuarios.vue?vue&type=script&lang=js&"
export * from "./Usuarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports